export default __webpack_public_path__ + "static/media/Mediator's Cloak.0cc5df97.jpg";